'use es6';

import keyMirror from 'react-utils/keyMirror';
const StandardErrorCategory = keyMirror({
  INVALID_AUTHENTICATION: null,
  INTERNAL_ERROR: null
});
export default StandardErrorCategory;